import { Breadcrumbs, CstmPagination } from 'components/Common/Common';
import DocViewModal from 'components/Common/DocViewModal';
import ErrorComponent from 'components/shared/ErrorComponent';
import LoadingIndicator from 'components/shared/LoadingIndicator';
import LoadingOverlay from 'components/shared/LoadingOverlay';
import TableLayoutV2New from 'components/TableLayoutV2 New';
import { dateFormat, successMessageToast } from 'helpers/common';
import { usePersistentState } from 'hooks/usePersistentState';
import React, { useEffect, useState } from 'react'
import { Alert, Col, Container, Row } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAgreeToPolicyMutation, useGetPoliciesListQuery } from 'store/services/policies';
import { useLazyGetFileUrlQuery } from 'store/services/utility';
import { authApi, useGetProfileQuery } from 'store/services/auth';
import { taskPlanTemplateFilter } from 'store/slices/filter';
import rightArrow from "Assets/images/rightArro.png"

function MyPolicies() {
    const dispatch = useDispatch()
    const location = useLocation();
    const navigate = useNavigate();
    const { data: profile } = useGetProfileQuery();
    const isPolicyAcceptanceRequired = location.state?.policyAcceptanceRequired === true;

    const [currentPage, setCurrentPage] = usePersistentState("school:page", 1);
    const [pageSize, setPageSize] = useState(10);
    const [selectedPolicy, setSelectedPolicy] = useState(null);
    const [showPolicyModal, setShowPolicyModal] = useState(false);

    useEffect(() => {
        if (isPolicyAcceptanceRequired && profile?.pending_policies_count != null && Number(profile.pending_policies_count) === 0) {
            setCurrentPage(1);
            navigate(`${location.pathname}${location.search}${location.hash}`, {
                replace: true,
                state: { ...location.state, policyAcceptanceRequired: false },
            });
        }
    }, [isPolicyAcceptanceRequired, profile?.pending_policies_count, location, navigate, setCurrentPage]);

    const filter = useSelector(state => state?.filter?.taskPlanTemplateFilter);
    const { data, isLoading, isError, isFetching } = useGetPoliciesListQuery(
        { page: currentPage, limit: pageSize, ...filter, pending: isPolicyAcceptanceRequired ? true : undefined }
    );
    const policies = data?.records;
    const totalRecords = data?.totalRecords ?? data?.total_records ?? 0;
    const totalPages = Math.ceil(totalRecords / pageSize);
    const [getFileUrl, { isLoading: isFileLoading, isFetching: isFileFetching }] = useLazyGetFileUrlQuery();
    const [agreeToPolicy, { isLoading: isAgreeing }] = useAgreeToPolicyMutation();

    const handlePageChange = (page) => {
        window.scrollTo(0, 0);
        setCurrentPage(page);
    };

    const handleFilterChange = (key) => (value) => {
        dispatch(taskPlanTemplateFilter({ ...filter, [key]: value }))
        setCurrentPage(1); // Reset to first page when filter changes
    };

    const column = [
        // {
        //   head: <div onClick={() => dispatch(policiesFilter({ ...filter, sort: filter?.sort?.column == "is_favorite" ? { column: "lastname", direction: "ASC" } : { column: "is_favorite", direction: "desc" } }))}>{filter?.sort?.column == "is_favorite" ? <Star fill="#93278F" stroke="#93278F" width={18} /> : <Star width={18} stroke="#8F8F8F" />}</div>,
        //   accessor: "is_favorite",
        //   isComponent: true,
        //   component: (item, ind) => (
        //     <h6 className="m-0 text-capitalize d-flex align-items-center gap-2"><div className="cursor-pointer" onClick={(e) => { e.stopPropagation(); handleFavouriteReport(item?.client_detail?.id, item?.client_detail?.is_favorite ? 0 : 1) }}>{item?.client_detail?.is_favorite ? <Star fill="#93278F" stroke="#93278F" width={18} /> : <Star width={18} stroke="#8F8F8F" />}</div></h6>
        //   ),
        // },

        {
            head: "POLICY NAME",
            accessor: "task_title",
            isComponent: true,
            sorter: true,
            width: "40%",
            component: (item) => (
                <div style={{ padding: "10px 5px" }}>
                    {item?.policy?.name || '-'}
                </div>
            )
        },
        {
            head: "DOCUMENT",
            accessor: "attachment_name",
            isComponent: true,
            sorter: false,
            width: "35%",
            component: (item) => (
                <div style={{ textAlign: 'center' }} title={item?.policy?.attachment_name}>
                    {item?.policy?.attachment_name || '-'}
                </div>
            )
        },
        {
            head: "DATE OF AGREEMENT",
            accessor: "agreed_at",
            isComponent: true,
            sorter: true,
            component: (item) => (
                <div className='d-flex justify-content-end'>
                    {item?.agreed_at ? dateFormat(item?.agreed_at, "MMM DD, YYYY") : 'Pending'}
                </div>
            )
        },


        {
            // head: "Action",
            accessor: "",
            isComponent: true,
            width: 70,
            component: (item, index) => (
                <div>
                    <img width={7} src={rightArrow} alt="Expand" />

                </div>
            ),
        },
    ];


    const handleViewPolicy = async (item) => {
        const attachmentKey = item?.policy?.attachment_key;

        if (!attachmentKey) return;

        try {
            const url = await getFileUrl(attachmentKey).unwrap();

            if (url) {
                setSelectedPolicy({
                    ...item.policy,
                    agreed_at: item.agreed_at,
                    url,
                });
                setShowPolicyModal(true);
            }
        } catch (error) {
            console.error("Error loading policy document", error);
        }
    }

    const handleAcceptPolicy = async () => {
        if (!selectedPolicy?.id) return;

        try {
            const result = await agreeToPolicy(selectedPolicy.id).unwrap();
            dispatch(authApi.util.invalidateTags(["Profile"]));
            successMessageToast(result?.message || "Policy accepted successfully.");
            setShowPolicyModal(false);
        } catch (error) {
            console.error("Error accepting policy", error);
        }
    };

    return (
        <>

            <section className='client position-relative py-2'>

                <Container fluid>
                <Breadcrumbs items={[{ label: "Profile", path: "/profile" }, { label: "My Policies & Procedures", path: "" }]} style={{ fontSize: "14px" }} />
                    {isPolicyAcceptanceRequired && (
                        <Alert variant="warning" className="mt-3 mb-0">
                            Please accept these policies before using the panel.
                        </Alert>
                    )}
                    {isLoading ? <div style={{ height: "200px" }}>  <LoadingIndicator /></div> :
                        <Col lg="12" className="my-2 mt-5">
                            <Row className='left classroom-conslutation d-flex justify-content-between align-items-end'>
                                <Col md="12" className=' d-flex align-items-end justify-content-between'>
                                    <div style={{ borderBottom: "1px solid #93278F", paddingBottom: "11px", width: "100%" }} className=' d-flex align-items-end justify-content-between'>
                                        <h6 style={{ fontSize: "26px" }} className="m-0  fw-bold main-head themeBlue">My Policies & Procedures</h6>
                                    </div>
                                </Col>
                                {/* <Col md="7">
                                    <Row className='d-flex justify-content-end mt-2'>
                                        <Col xs="7">
                                            <div className="d-flex align-items-center gap-3 search-input-filter-v2 readonly-box">
                                                <input
                                                    onChange={(e) => handleSearchChange(e.target.value)}
                                                    className="border-0 shadow-none h-auto w-100"
                                                    placeholder="Type to search for a template"
                                                    defaultValue={filter?.search}
                                                    style={{ outline: "none" }}
                                                />
                                                <SearchIcon />
                                            </div>
                                        </Col>
                                        <Col xs="4" xl="3" className=' d-flex justify-content-center'>
                                            <CommonButton className="staff-button-filled" text="Create New" onClick={() => navigate(TASK_PLAN_TEMPLATES_ADD)} />
                                        </Col>

                                    </Row>
                                </Col> */}


                            </Row>

                            <div className="table-outer mt-3">

                                {isError ? (
                                    <ErrorComponent />
                                ) : (
                                    <>
                                        {(isFetching || isFileLoading || isFileFetching) && <LoadingOverlay />}
                                        <TableLayoutV2New
                                            borderColor='#93278F'
                                            data={policies}
                                            column={column}
                                            filter={filter}
                                            handleSort={handleFilterChange("sort")}
                                            // handleGetRowColor={handleGetRowColor}
                                            handleRowClick={handleViewPolicy}
                                        />
                                    </>
                                )}
                                <CstmPagination
                                    totalPages={totalPages}
                                    className={'paginationV2'}
                                    activePage={currentPage}
                                    handlePageChange={handlePageChange}
                                />
                            </div>
                        </Col>
                    }
                </Container>

            <DocViewModal
                show={showPolicyModal}
                setShow={setShowPolicyModal}
                doc={selectedPolicy}
                onAccept={handleAcceptPolicy}
                showAccept={!selectedPolicy?.agreed_at}
                isAccepting={isAgreeing}
            />
            </section>
        </>
    )
}

export default MyPolicies
